import { Button } from "@material-ui/core";
import rg4js from "raygun4js";
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import img from "../assets/images/bug-report.png";
import { authActions } from "../store/actions/auth.actions";
import { AuthState } from "../store/reducers/auth.reducer";
import { IDRaksStore } from "../store/store";

const ErrorBoundaryStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  max-width: 100%;
  height: 100vh;
  background-color: ${(props) => props.theme.palette.background.paper};

  .error-boundary-message {
    margin: 56px 0;
  }

  .error-boundary-back-btn {
    width: 328px;
    height: 59px;
    font-size: 16px;
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
    rg4js("enableCrashReporting", true);
    rg4js("apiKey", "HfzV0PRAmppohnQIQZA");
    rg4js("withTags", ["CLIENT"]);
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({ hasError: true });
    const user = (this.props as any).user as AuthState;
    rg4js("setUser", {
      identifier: user.userId,
      email: user.user,
      isAnonymous: !user.isLogged,
    });
    rg4js("send", error);
  }

  render() {
    if ((this.state as any).hasError) {
      return (
        <ErrorBoundaryStyle>
          <img src={img} alt="error_img" className="raks-bitmap" />
          <h4 className="error-boundary-message">
            Niestety wystąpił nieoczekiwany błąd.
          </h4>
          <Button
            variant="contained"
            className="error-boundary-back-btn"
            color="secondary"
            onClick={() => {
              (this.props as any).onLogout();
              window.location.reload();
            }}
          >
            Wróć do programu
          </Button>
        </ErrorBoundaryStyle>
      );
    }
    return this.props.children;
  }
}

const mapStateToProps = (store: IDRaksStore) => {
  return { user: store.auth };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    onLogout: () => dispatch(authActions.logout()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorBoundary as any);
